import { render, staticRenderFns } from "./SortShop.vue?vue&type=template&id=bf10038c&scoped=true&"
import script from "./SortShop.vue?vue&type=script&lang=js&"
export * from "./SortShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf10038c",
  null
  
)

export default component.exports